import { render, staticRenderFns } from "./BalancePre.vue?vue&type=template&id=5ab972b2&scoped=true"
import script from "./BalancePre.vue?vue&type=script&lang=js"
export * from "./BalancePre.vue?vue&type=script&lang=js"
import style0 from "./BalancePre.vue?vue&type=style&index=0&id=5ab972b2&prod&scoped=true&lang=less"
import style1 from "./BalancePre.vue?vue&type=style&index=1&id=5ab972b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab972b2",
  null
  
)

export default component.exports